export const isSignedIn = (): boolean => {
  if (document.getElementById("posts_new")) {
    return true;
  }
  return false;
};
